<template>
    <div class="my-10 bg-white rounded px-6 py-6 text-justify">

        <p class="mb-3">
            {{ $t("thankYouForInterest") }}
        </p>
        <p class="pb-6 mb-6 border-b">
            {{ $t("cannotOnboard") }}
        </p>

        <p class="mb-3">
            {{ $t("aiMeaning") }}
        </p>

        <p class="mb-3">
            {{ $t("individual") }}
        </p>
        <p class="ml-4 mb-3 text-sm">
            {{ $t("aiMeaningA") }}
        </p>
        <p class="ml-4 mb-3 text-sm">
            {{ $t("aiMeaningB") }}
        </p>

        <p class="mt-6 mb-3">
            {{ $t("aiMeaningII") }}
        </p>

        <p class="ml-4 mb-3 text-sm">
            {{ $t("aiMeaningIIA") }}
        </p>
        <p class="ml-4 mb-3 text-sm">
            {{ $t("aiMeaningIIB") }}
        </p>
        <p class="mt-6 border-t pt-6" v-html="$t('questions')">
        </p>
        <p class="mt-3" v-html="$t('yoursKilde')">
        </p>
    </div>
</template>
<script>
export default {
    methods: {
        bookACall() {
            try {
                // eslint-disable-next-line no-undef
                let investorName = this.$root.$data.investorProfile.firstName + ' ' + this.$root.$data.investorProfile.lastName;
                let investorEmail = this.$root.$data.investorProfile.email;
                let investorPhone = this.$root.$data.investorProfile.mobilePhone;
                Calendly.showPopupWidget(`https://calendly.com/kilde-investors/lets-talk-with-us?name=${investorName}&email=${investorEmail}&a1=${investorPhone}`);
            } catch (e) {
                console.log('Error', e);
            }
        }
    },
    created() {
        this.$scriptLoader.loadScript('https://calendly.com/assets/external/widget.js')
        this.$scriptLoader.loadStyle('https://calendly.com/assets/external/widget.css')
    }

}
</script>
